import React, { useContext } from 'react';
import Lottie from 'react-lottie';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthProvider';
import LoadingAnimationLottie from '../../LoadingAnimationLottie.json';

const PrivateRoute = ({ children }) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: LoadingAnimationLottie,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        }
    };

    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <div>
            <Lottie options={defaultOptions}
                height={400}
                width={400} />
        </div>

    }

    if (user) {
        return children;
    }

    return <Navigate to="/login" state={{ from: location }} replace></Navigate>;
};

export default PrivateRoute;